<template>
  <hb-basic-page
    :action-buttons="$vuetify.breakpoint.smAndDown ? { add: titleButton } : {}"
    :fill-height="richSurveyTemplates.length === 0"
    :loading="loading"
    :search-title="`${$t('survey_templates.search')}...`"
    :subtle-loading="subtleLoading"
    :title="$tc('survey_templates.title', 2)"
    :title-button="titleButton"
    name="surveytemplates-view"
    @handle-search="handleSearch"
  >

    <v-col v-if="!loading && richSurveyTemplates.length > 0" cols="12" lg="8" md="10" offset-lg="2" offset-md="1"
           offset-xl="3"
           xl="6">
      <v-row>
        <v-col cols="12">
          <SectionHeader icon="mdi mdi-clipboard-list-outline">
            <v-icon color="primary" left size="36"></v-icon>
            {{ $t('survey_templates.active_survey_templates') }}
          </SectionHeader>
          <v-list color="transparent">
            <template v-for="surveyTemplate in activeRichSurveyTemplates">
              <survey-template-item :key="surveyTemplate.key" :survey-template="surveyTemplate" @reload="reload"/>
            </template>
          </v-list>
          <v-btn :large="$vuetify.breakpoint.smAndUp" :small="$vuetify.breakpoint.xsOnly" block color="primary" text
                 @click="handleCreateSurveyTemplate">
            <v-icon left>add</v-icon>
            {{ $t('survey_templates.create') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <SectionHeader icon="mdi mdi-history">
            {{ $t('survey_templates.non_active_survey_templates') }}
          </SectionHeader>
          <v-list color="transparent">
            <template v-for="surveyTemplate in nonActiveRichSurveyTemplates">
              <survey-template-item :key="surveyTemplate.key" :survey-template="surveyTemplate" @reload="reload"/>
            </template>
          </v-list>
        </v-col>
      </v-row>
    </v-col>

    <v-col v-if="!loading && richSurveyTemplates.length === 0" class="pa-0 fill-height" cols="12">
      <v-row align="center" class="fill-height" no-gutters>
        <no-content-view v-if="!loading && richSurveyTemplates.length === 0"
                         :description="$t('survey_templates.create_first_survey_template_help')"
                         :function-button="true"
                         :function-button-text="$t('survey_templates.create')"
                         :prop-function="handleCreateSurveyTemplate"
                         :reload-button="false"
                         :title="$t('survey_templates.create_first_survey_template')"
                         function-button-icon="add"
                         title-icon="mdi mdi-clipboard-multiple-outline"/>
      </v-row>
    </v-col>

  </hb-basic-page>
</template>

<script>
import NoContentView from "@/components/NoContentView";
import SectionHeader from "@/components/SectionHeader";
import surveyTemplateApi from "@/api/surveytemplate";
import SurveyTemplateItem from "@/components/SurveyTemplates/SurveyTemplateItem";


export default {
  name: 'SurveyTemplatesView',
  components: {SurveyTemplateItem, SectionHeader, NoContentView},
  data() {
    return {
      loading: true,
      subtleLoading: false,
      searchPhrase: '',
      titleButton: {
        text: this.$t('survey_templates.create'),
        icon: 'add',
        callback: this.handleCreateSurveyTemplate,
        primary: true,
      },
      surveytemplates: [],
    };
  },
  computed: {
    richSurveyTemplates() {
      return this.surveytemplates.map(s => {
        return s;
      })
    },
    nonActiveRichSurveyTemplates() {
      return this.richSurveyTemplates.filter(s => !s.active)
    },
    activeRichSurveyTemplates() {
      return this.richSurveyTemplates.filter(s => s.active)
    }
  },
  methods: {
    handleSearch(searchPhrase) {
      this.searchPhrase = searchPhrase;
    },
    handleCreateSurveyTemplate() {
      this.$router.push({name: 'create_survey_template'});
    },

    async reload() {
      this.loading = true;
      if (this.surveytemplates.length > 0) this.subtleLoading = true;
      this.surveytemplates = await surveyTemplateApi.getSurveyTemplates();
      this.loading = false;
      this.subtleLoading = false;
    },
    test(e) {
      console.log(e);
    }
  },
  mounted() {
    if (!this.$hasMatchingRoles(['admin'])) {
      this.$router.replace({name: 'access_denied'});
      return;
    }
    this.loading = true;
    this.reload();
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss"></style>
